// var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
// var eventer = window[eventMethod];
// var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
//
// const dataCaptureState = {
//     status: false,
//     data: {},
// };
// // Listen to message from child window
// eventer(messageEvent, function (e) {
//     // console.log('eee', e);
//
//     var key = e.message ? "message" : "data";
//     var data = e[key] || false;
//
//     if (!data || data.type !== "ekyc_DC_Response") {
//         return;
//     }
//
//     dataCaptureState.status = true;
//     dataCaptureState.data = data.data;
//
// }, false);
//

export const EkycDataCapture = function (ekycParams) {

    const params = {
        ...ekycParams
    };

    const apiUrl = params.ekyc_endpoint;
    delete params.ekyc_endpoint;

    const formObject = {
        ...params
    }

    const basicAuthToken = params.token;

    const jsonString = JSON.stringify(formObject);

    // Build the full URL for the fetch request dynamically
    const apiUrlEndpoint = `${apiUrl}/IslWebAPI/faces/pages/webapi.xhtml`;

    // console.log('apiUrl2', apiUrlEndpoint);

    // dataCaptureState.status = false;


    return new Promise((resolve, reject) => {
        // Perform the fetch request
        fetch(apiUrlEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${basicAuthToken}` // Include encrypted token in the header
            },
            body: jsonString,
            credentials: 'include',
            mode: 'cors',
            redirect: 'follow', // Prevent auto-following of redirects

        })
            .then(response => {
                if (!response.ok) {
                    // console.log('response',response)
                    throw new Error('Network response was not ok');
                }
                return response.text(); // Get the response as HTML text
            })
            .then(html => {

                const res = {
                    html: html,
                    apiUrl: apiUrl,
                };

                resolve(res);
                return res;
            })
            .catch((error) => {

                console.error('Error:', error); // Log any errors to the console

                reject({
                    step: 'data-capture',
                    action: 'error',
                    message: 'عذراً، لا يمكنك استخدام هذه الخدمة في الوقت الحالي.',
                    error: error
                });

                return error;
            });

    })

}